// openSetPasswordDirectorModal.js
'use strict';
import fetchAccountLinks from '../action/fetchAccountLinks.js';
import addModal from '../action/addModal.js';
import getMeData from '../selector/getMeData.js';
import { getIsChinaPartner } from '../resource/partner.js';

/**
 * Open set password director modal
 * @kind action
 * @return {Promise} Action promise.
 */
const openSetPasswordDirectorModal = () => async (dispatch, getState) => {
  const isChinaPartner = getIsChinaPartner();
  if (isChinaPartner) {
    return dispatch({ type: '' });
  }
  await dispatch(fetchAccountLinks());
  const isEmailBound = getMeData(getState(), 'isEmailBound');
  const isPasswordBound = getMeData(getState(), 'isPasswordBound');
  // if username not set, should let user set first.
  const isUsernameSet = getMeData(getState(), 'flightCheck')?.isUsernameSet;
  if (isEmailBound && !isPasswordBound && isUsernameSet) {
    dispatch(
      addModal({
        id: 'SetPasswordDirectorModal',
        isHigherThanAll: true,
      })
    );
  }
};

export default openSetPasswordDirectorModal;
